// zh.ts
export default {
	language: {
		title: '中文',
		code: 'ZH',
	},
	company: {
		name: '北境骑团',
		describe: '源自一群热爱骑行的伙伴们。它是一个品牌，也是一个平台，我们秉承着开放、包容、接纳的理念，与更多的伙伴并肩前行，探索骑行乐趣。你所付出的每一份善意与温暖，终将会以快乐的形式回归自身。开放是积极的心态，包容是宽阔的胸怀，接纳是灵魂的归属。无论你来自何方，只要相识，不负遇见。',
		join: '立即加入',
		slogan: '探索无界，北境相伴',

		

		contact: '联系方式',
		contact_us: '联系我们',
		contact_us_desp: '无论您有任何问题或建议，都欢迎随时与我们联系。我们的团队将竭诚为您服务。',
		contact_information: '联系方式',
		contact_follow_us: '关注我们',
	},
	header: {
		homePage: '首页',
		//############################################# 自行车
		bike: '自行车',
		road_bike: '公路自行车',
		mountain_bike: '山地自行车',
		folding_bike: '折叠自行车',
		kids_bike: '儿童自行车',
		//############################################# 配件
		accessory: '车配件',
		
		handlebar: '车把',
		car_bell: '车铃',
		car_lock: '车锁',

		brake: '刹车',
		variable_speed: '变速',

		drivetrain: '传动系统',
		crank: '曲柄',
		chain: '链条',
		pedal: '脚踏',

		seat: '车座',
		seat_post: '座杆',

		wheels: '轮胎',
		wheel_set: '轮组',
		stickers: '贴纸',
		bicycle_pump: '打气筒',
		//############################################# 服装/更多
		apparel: '服装/更多',
		helmets: '头盔',
		shoes: '鞋子',
		clothing: '骑行服',
		other: '其它',
		//############################################# 促销
		bike_or_more: '自行车/更多',
		//############################################# 促销
		sale: '促销',
		//############################################# 新闻资讯
		news_press_releases: '新闻资讯',
		//############################################# 关于我们
		about: '关于我们',
		culture_and_values: '文化和价值观',
		milestone: '里程碑',
		leadership_team: '领导团队',
		our_business: '我们的业务',
		security_check: '防伪查询',
	},
	security_check: {
		title: '防伪查询',
		description: '通过我们的防伪系统，您可以验证产品的真伪，确保购买到正品。',
	},
	website: {
		home: '首页',
		about: '关于北境',
		products: '产品体系',
		partnership: '合作伙伴',
		contact: '联系我们',
	}
};
